
<template>
    <rkm-form ref="Form">
        <box-alteracao
            v-if="loaded"
            :data="{ initials, form, model }"
            @handleStatusAgendado="handleStatusAgendado"
        />
    </rkm-form>
</template>

<script>
import BoxAlteracao from '@/components/exame-imagem/alteracao-exame-finalizado/components/Form'

import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

//Enuns.
import statusFechamento from '@/enums/exame-imagem/fechamento/status'

export default {
    components: { BoxAlteracao },
    created() {

        this.repositories = {
            alteracao: this.getConectaSusRepository('exameImagem.alteracaoExameFinalizado')
        }
        this.load()
    },
    data: () => ({
        loaded: false,
        initials: {
            model: {}
        },
        form: {},
        model: {},
        enums: {
            statusFechamento
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.alteracao.list()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save(){

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if(this.handleStatus == this.enums.statusFechamento.AGENDADO){

                        const confirm = async () => {

                            this.setLoading()

                            this.repositories.alteracao.store(this.prepareData())
                            .then(({ data }) => {

                                this.showSaveNotification()
                                this.$emit('save', data)

                                this.loadList()
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())

                            return false
                        }

                        const cancel = async () => { }

                        const msg = `Ao substituir o status do exame para AGENDADO, ele retornará para a listagem` +
                            ` de <strong>fechamento de exames</strong>, caso haja laudo adicionado o mesmo será` +
                            ` perdido. Deseja continuar?`

                        this.showConfirmation(msg, confirm, cancel)

                        return false

                    } else {

                        this.setLoading()

                        this.repositories.alteracao.store(this.prepareData())
                            .then(({ data }) => {

                                this.showSaveNotification()
                                this.$emit('save', data)

                                this.loadList()
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        prepareData() {

            const model = this.clone(this.model)

            return this.camelObjectKeysToSnakeRecursive(model)
        },
        loadList(){

            this.setLoading()

            this.repositories.alteracao.list()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                })
                .finally(() => this.unsetLoading())
        },
        handleStatusAgendado(value){

            this.handleStatus = value
        }
    },
    mixins: [repository, error, object, data, stringCase]
}
</script>